import { render, staticRenderFns } from "./CollectedBar.vue?vue&type=template&id=b588a5be&scoped=true&functional=true&"
import script from "./CollectedBar.vue?vue&type=script&lang=js&"
export * from "./CollectedBar.vue?vue&type=script&lang=js&"
import style0 from "./CollectedBar.vue?vue&type=style&index=0&id=b588a5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b588a5be",
  null
  
)

export default component.exports